// Franja de la solapa del media plan (C6 del diseño «grupos, dinero y DV360», para todas las
// agencias). Módulo puro para testearlo sin montar la vista de conexiones.
//
// La franja se dibuja siempre que la conexión esté ACTIVA, aunque todavía no haya escaneo: es justo
// cuando el usuario necesita saber qué se lee y poder elegirlo. Antes dependía de `tab_scan` y una
// conexión recién creada no mostraba nada.

export const TAB_STRIP_KINDS = Object.freeze({
    READING: 'reading',          // hay una solapa elegida: «Lee la solapa «X»»
    NOT_SCANNED: 'not_scanned',  // nunca se escaneó: «Todavía no leímos la planilla.»
    NONE: 'none',                // se escaneó y ninguna solapa sirvió para el período
});

export function tabStripState(scan) {
    const title = ((scan || {}).selected || {}).title || '';
    if (title) return {kind: TAB_STRIP_KINDS.READING, tab: title};
    // Un escaneo sin `outcome` es el que guarda «Actualizar lista» sobre una conexión nunca leída:
    // trae las solapas pero no se eligió ninguna, así que para el usuario sigue sin leerse.
    if (!scan || !scan.outcome || scan.outcome === 'NEVER_SCANNED') {
        return {kind: TAB_STRIP_KINDS.NOT_SCANNED};
    }
    return {kind: TAB_STRIP_KINDS.NONE};
}

// El dato que acompaña al nombre: el motivo del descarte (ámbar, es lo accionable), si se fijó a
// mano, entre cuántas se eligió, o de qué mes es el plan. Devuelve la clave relativa a
// `media_plan.connections.tab` y sus valores, o null si no hay nada que decir.
export function tabStripHint(scan) {
    if (!scan) return null;
    const reason = (scan.reasons || [])[0];
    if (reason && reason.code) return {key: `reason.${reason.code}`, values: {}, tone: 'warn'};
    if (scan.pinned_gid !== null && scan.pinned_gid !== undefined) {
        return {key: 'manual', values: {}, tone: ''};
    }
    const period = scan.target_month || '';
    const candidates = (scan.counts || {}).candidates || 0;
    if (candidates > 1) return {key: 'auto_among', values: {count: candidates, period}, tone: ''};
    if (period) return {key: 'reading_auto_hint', values: {period}, tone: ''};
    return null;
}

// `GET media-plan/tabs/` responde el escaneo PELADO (sin `status`) en el éxito y `{status, ...}` en
// el error: se distingue por la forma. `status === 'OK'` mandaría todo éxito a la rama de error.
export function isTabsPayload(data) {
    return !!data && Array.isArray(data.tabs);
}

// Mes «YYYY-MM» del navegador. Lo usa el selector cuando el escaneo todavía no tiene `target_month`
// (conexión nunca leída): el backend fija el pin en el mes corriente en ese caso, así que es el mes
// que corresponde nombrar.
export function currentMonthKey(now = new Date()) {
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
